import { combineReducers } from 'redux';

import taiKhoan from './TaiKhoan/TaiKhoan.slice';

export default combineReducers({
  taiKhoan,
});
